import React, { Component } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import axios from 'axios';
import {CSVLink, CSVDownload} from 'react-csv';
import PropTypes from 'prop-types';
import dateHelper from '../../helpers/date.js';

class CSVExport extends Component {
    constructor(props) {
        super(props);
    };

    loadData() {
        axios
            .get(this.props.ajaxUrl, { params: this.props.parameters })
            .then(function(data) {
                if(data.data && data.data.length > 0) {
                    this.downloadCSV(data.data);
                }
            }.bind(this))
            .catch(function(error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                this.setState({ isError: true });
                console.log(error);
            }.bind(this));
    };

    exprotClicked() {
        this.loadData();
    }

    convertArrayOfObjectsToCSV(args) {
        var result, ctr, keys, okeys, columnDelimiter, lineDelimiter, data;

        data = args.data || null;
        if (data == null || !data.length) {
            return null;
        }

        columnDelimiter = args.columnDelimiter || ',';
        lineDelimiter = args.lineDelimiter || '\r\n';




        keys = this.props.dbKeys || Object.keys(data[0]);
        okeys = [];

        if(this.props.csvKeys) {
            this.props.csvKeys.forEach(function(key) {
                okeys.push('"' + key + '"');
            });
        } else {
            keys.forEach(function(key) {
                okeys.push('"' + key + '"');
            });
        }

        result = '';
        result += okeys.join(columnDelimiter);
        result += lineDelimiter;

        data.forEach(item => {
            ctr = 0;
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                if (ctr > 0) result += columnDelimiter
                var val = item[key];
                if(key == 'TimeStamp' || key == 'Subscribed' || key == 'LastActive') {
                    val = dateHelper.fromDBStrToStrWithTime(val);
                }

                if (this.props.dataFormatters && this.props.dataFormatters[i]) {
                    val = this.props.dataFormatters[i](val);
                }

                if (typeof val === 'string') {
                    val = val.replace(/"/g, "").replace(/{/g, "").replace(/}/g, "").replace(/,/g, "-").trim();
                }

                
                if(val) {
                    result += '"' + val + '"';
                } else {
                    result += '""';
                }

                
                ctr++;
            }


/*
            keys.forEach(function(key) {
                if (ctr > 0) result += columnDelimiter
                var val = item[key];
                if(key == 'TimeStamp') {
                    val = dateHelper.fromDBStrToStrWithTime(val);
                }


                if (typeof val === 'string') {
                    val = val.replace(/"/g, "").replace(/{/g, "").replace(/}/g, "").replace(/,/g, "-").trim();
                }

                

                result += '"' + val + '"';
                ctr++;
            });*/
            result += lineDelimiter;
        });

        return result;
    }

    downloadCSV(exportData) {
        var data, link;

        var csv = this.convertArrayOfObjectsToCSV({
            data: exportData
        });
        if (csv == null) return;
        if (!csv.match(/^data:text\/csv/i)) {
            csv = 'data:text/csv;charset=utf-8,' + csv;
        }
        data = encodeURI(csv);
        link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', this.props.fileName);
        link.click();
    }

    render() {
        return (
            <Button bsStyle="link" bsSize="large" onClick={() => this.exprotClicked()}>
                <Glyphicon glyph="glyphicon glyphicon-floppy-save" />
            </Button>
        );
    };
}



CSVExport.defaultProps = {
    fileName: 'report.csv'
}

CSVExport.propTypes = {
    ajaxUrl: PropTypes.string,
    fileName: PropTypes.string,
    parameters: PropTypes.object
};

module.exports = CSVExport;


// WEBPACK FOOTER //
// ./modules/common/CSVExport.jsx